import { render, staticRenderFns } from "./TagsSidebar.vue?vue&type=template&id=9f0c0cc4&scoped=true"
import script from "./TagsSidebar.vue?vue&type=script&lang=js"
export * from "./TagsSidebar.vue?vue&type=script&lang=js"
import style0 from "./TagsSidebar.vue?vue&type=style&index=0&id=9f0c0cc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0c0cc4",
  null
  
)

export default component.exports